import { mapGetters } from "vuex"

const handles_newsletter_notification = {
    methods: {
        load_newsletter_notification () {
            this.loading_newsletter_notification = true
            this.$store.dispatch(
                "FETCH_RECORDS",
                {
                    entity: "delayed_notification",
                    query: { name: this.default_newsletter_notification.name }
                }
            ).catch(error => {
                console.error(error)
            }).then(() => {
                this.loading_newsletter_notification = false
            })
        },
        reset_newsletter_notification () {
            const newsletter_notification = this.newsletter_notification
            if(newsletter_notification.id) {
                this.$confirm({
                    type: "error",
                    title: "Cancel Scheduled Newlsetter",
                    message: "Are you sure you want to cancel the newsletter? All the text you have entered will also be deleted. Alternatively, you can send the newsletter now, or re-schedule it.",
                    cancel: "Keep It",
                    ok: "Cancel It",
                    then: (confirmed) => {
                        if(confirmed) {
                            this.$store.dispatch("RECORD_DELETE", {
                                entity: "delayed_notification",
                                id: newsletter_notification.id
                            }).catch(error => {
                                if(error) this.$error(error.message)
                            })
                        }
                    }
                })
            }
        },
        send_newsletter_notification (preview = false) {
            const { id, ...data } = this.newsletter_notification
            data.preview = preview

            let dispatch
            if(id) {
                dispatch = this.$store.dispatch("RECORD_SAVE", {
                    entity: "delayed_notification",
                    id,
                    data
                })
            } else {
                dispatch = this.$store.dispatch("CREATE_RECORD", {
                    entity: "delayed_notification",
                    data
                })
            }

            this.saving_newsletter_notification = true
            dispatch.then(() => {
                if(preview) {
                    this.$success("Newsletter Preview: A preview of the newsletter has been sent to your email address")
                } else {
                    if(data.send_at) {
                        const date = this.$moment(data.send_at)
                        this.$success(`Newsletter Scheduled: It should be going out on ${date.format("D MMMM")}.`)
                    } else this.$success("Newsletter Scheduled: It should be going out in the next few minutes.")
                    this.sent_newsletter_notification()
                }
            }).catch(error => {
                this.$error(error.message || error)
            }).then(() => {
                this.saving_newsletter_notification = false
            })
        },
        sent_newsletter_notification () {

        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_delayed_notifications () {
            return this.entity_records("delayed_notification")
        },
        newsletter_notification () {
            const newsletter_notification = this.raw_delayed_notifications.find(notification => notification.name === this.default_newsletter_notification.name)
            return newsletter_notification || this.default_newsletter_notification
        }
    },
    data () {
        return {
            loading_newsletter_notification: false,
            saving_newsletter_notification: false,
            default_newsletter_notification: {
                id: 0,
                name: "Newsletter",
                content: {
                    send_to: [],
                    this_week_notes: "",
                    next_week_notes: "",
                    conclusion: ""
                },
                send_at: ""
            }
        }
    }
}

export default handles_newsletter_notification
